export default __webpack_public_path__ + "static/media/twelve-week-sprint.7af4d18d.svg";